const KEY = "cocoa_notif_prefs";

export const NOTIF_CATEGORIES = [
  ["clinical", "Clinical"],
  ["task", "Tasks"],
  ["schedule", "Schedule"],
  ["portal", "Portal requests"],
  ["billing", "Billing"],
  ["expiring", "Expiring documents"],
  ["system", "System"],
];

export const DEFAULT_NOTIF_PREFS = {
  enabled: true,
  sound: false,
  categories: Object.fromEntries(NOTIF_CATEGORIES.map(([k]) => [k, true])),
};

export function getNotifPrefs() {
  try {
    const p = JSON.parse(localStorage.getItem(KEY));
    if (!p) return { ...DEFAULT_NOTIF_PREFS };
    return { ...DEFAULT_NOTIF_PREFS, ...p, categories: { ...DEFAULT_NOTIF_PREFS.categories, ...(p.categories || {}) } };
  } catch {
    return { ...DEFAULT_NOTIF_PREFS };
  }
}

export function saveNotifPrefs(p) {
  try { localStorage.setItem(KEY, JSON.stringify(p)); } catch { /* storage unavailable */ }
}

export function playChime() {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.connect(g);
    g.connect(ctx.destination);
    o.type = "sine";
    o.frequency.value = 880;
    g.gain.setValueAtTime(0.08, ctx.currentTime);
    g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.4);
    o.frequency.setValueAtTime(1174.66, ctx.currentTime + 0.12);
    o.start();
    o.stop(ctx.currentTime + 0.45);
    setTimeout(() => ctx.close().catch(() => {}), 600);
  } catch { /* audio unavailable */ }
}
